module.exports = __webpack_public_path__ + "img/smart-zone-logo.8938fe29.svg";